import React from "react";
import { COLUMN_TYPES } from "./DatabaseColumnItem";
import "./TableCardPreview.css";

const TYPE_BY_VALUE = new Map(COLUMN_TYPES.map((type) => [type.value, type]));

export function getColumnTypeLabel(type) {
  return TYPE_BY_VALUE.get(type)?.label || "Text";
}

export function getColumnTypeIcon(type) {
  return TYPE_BY_VALUE.get(type)?.icon || null;
}

/* Rows that fit in the fixed-height template hero without clipping: up to 5 when
 * they're all shown, or 4 + a "+N more" chip when there are extras. */
const MAX_ROWS = 5;
const ROWS_WITH_MORE = 4;

/**
 * Mini preview of a table's schema for the create-table template cards: a compact
 * vertical list of columns (type icon + column name + short type label), so the
 * card looks like the table it creates. Mirrors BoardCardPreview's "flow" layout.
 *
 * Accepts a `columns` array (`{ name, type }`). `maxItems` caps how many columns
 * render before the rest collapse into a "+N more" chip.
 */
export default function TableCardPreview({
  columns = [],
  maxItems,
  className = "",
}) {
  const cap =
    maxItems ?? (columns.length > MAX_ROWS ? ROWS_WITH_MORE : MAX_ROWS);
  const shown = columns.slice(0, cap);
  const overflow = columns.length - shown.length;

  return (
    <div className={`table-card-preview${className ? ` ${className}` : ""}`}>
      {shown.map((column, i) => {
        const Icon = getColumnTypeIcon(column.type);
        return (
          <div className="table-card-preview__row" key={column.name || i}>
            {Icon && (
              <Icon
                className="table-card-preview__icon"
                sx={{ fontSize: 13, color: "text.disabled", flexShrink: 0 }}
              />
            )}
            <span className="table-card-preview__name">
              {column.name || "Column"}
            </span>
            <span className="table-card-preview__type">
              {getColumnTypeLabel(column.type)}
            </span>
          </div>
        );
      })}
      {overflow > 0 && (
        <div className="table-card-preview__more">+{overflow} more</div>
      )}
    </div>
  );
}
